import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import classnames from 'classnames';
import ReactHTMLParser from 'react-html-parser';
import styled from 'styled-components';
import { COLOR, FONT_SIZE, MARGIN, BREAKPOINT } from '@latitude/core/utils/constants';
import { Heading3 } from '@latitude/heading';
import Section from '@latitude/section';
import { Link } from '@latitude/link';
import { Text } from '@latitude/text';
import './_important-information.scss'; // Convert all anchor elements to Link components with analytics

var transform = function transform(node) {
  if (node.name === 'a') {
    return /*#__PURE__*/React.createElement(Link, Object.assign({
      variant: COLOR.BLUE
    }, node.attribs['data-trackid'] ? {
      trackId: node.attribs['data-trackid']
    } : {}, {
      trackEventData: {
        label: node.attribs.id,
        location: "important-information"
      },
      href: node.attribs.href
    }), node.children[0].data);
  }
};

var ImportantInformation = function ImportantInformation(props) {
  var Icon = require("@latitude/svg-inline/images/" + ((props === null || props === void 0 ? void 0 : props.icon) || 'attention') + ".svg");

  var StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
    displayName: "ImportantInformation__StyledIcon",
    componentId: "sc-nd05cm-0"
  })(["height:34px;width:34px;stroke:", ";flex-shrink:1;@media (min-width:", "){height:40px;width:40px;}"], COLOR.BLACK, BREAKPOINT.LG);
  return /*#__PURE__*/React.createElement(Section, {
    id: props.id,
    className: classnames('section--important-info', props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    "data-contentful": props === null || props === void 0 ? void 0 : props.contentfulID
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("section", {
    className: "important-info"
  }, /*#__PURE__*/React.createElement("header", {
    className: "important-info__header"
  }, /*#__PURE__*/React.createElement(StyledIcon, null), /*#__PURE__*/React.createElement(ImportantInfoTitle, null, (props === null || props === void 0 ? void 0 : props.title) || 'Important information')), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: props.sectionOneColummClasses
  }, props.data.content.importantInformationSectionOne.map(function (line, i) {
    return /*#__PURE__*/React.createElement(_StyledText, {
      className: "important-info__text",
      key: i,
      fontSize: FONT_SIZE.SMALL,
      $_css: MARGIN.M16
    }, ReactHTMLParser(line, {
      transform: transform
    }));
  })), props.data.content.importantInformationSectionTwo && /*#__PURE__*/React.createElement("div", {
    className: props.sectionTwoColummClasses
  }, props.data.content.importantInformationSectionTwo.map(function (line, i) {
    return /*#__PURE__*/React.createElement(_StyledText2, {
      className: "important-info__text",
      key: i,
      fontSize: FONT_SIZE.SMALL,
      $_css2: MARGIN.M16
    }, ReactHTMLParser(line, {
      transform: transform
    }));
  }), props.additionalPaymentsDisclaimerOne && /*#__PURE__*/React.createElement(_StyledText3, {
    id: "additional-payments",
    className: "important-info__text",
    fontSize: FONT_SIZE.SMALL,
    $_css3: MARGIN.M16
  }, ReactHTMLParser(props.data.content.additionalPaymentsDisclaimerOne, {
    transform: transform
  })), props.additionalPaymentsDisclaimerTwo && /*#__PURE__*/React.createElement(_StyledText4, {
    className: "important-info__text",
    fontSize: FONT_SIZE.SMALL,
    $_css4: MARGIN.M16
  }, ReactHTMLParser(props.data.content.additionalPaymentsDisclaimerTwo, {
    transform: transform
  }))))))));
}; // ImportantInformation.propTypes = {
//   /** data object containing the inner content */
//   data: PropTypes.shape({
//     /** Lines of text to display in first column */
//     importantInformationSectionOne: PropTypes.arrayOf(PropTypes.string),
//     /** Lines of text to display in second column */
//     importantInformationSectionArray: PropTypes.arrayOf(PropTypes.string)
//   }).isRequired,
//   /** add additional css class to the container */
//   className: PropTypes.string,
//   /** add additional css class to the first column container */
//   sectionOneColummClasses: PropTypes.string,
//   /** add additional css class to the second column container */
//   sectionTwoColummClasses: PropTypes.string,
//   additionalPaymentsDisclaimerOne: PropTypes.bool,
//   additionalPaymentsDisclaimerTwo: PropTypes.bool
// };


var ImportantInfoTitle = /*#__PURE__*/styled(Heading3).withConfig({
  displayName: "ImportantInformation__ImportantInfoTitle",
  componentId: "sc-nd05cm-1"
})(["font-size:20px;line-height:32px;margin:0 0 0 12px;color:", ";font-weight:600;@media (min-width:", "){font-size:24px;margin:0 0 0 24px;}"], COLOR.BLACK, BREAKPOINT.LG);
export default ImportantInformation;

var _StyledText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ImportantInformation___StyledText",
  componentId: "sc-nd05cm-2"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css;
});

var _StyledText2 = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ImportantInformation___StyledText2",
  componentId: "sc-nd05cm-3"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css2;
});

var _StyledText3 = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ImportantInformation___StyledText3",
  componentId: "sc-nd05cm-4"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css3;
});

var _StyledText4 = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ImportantInformation___StyledText4",
  componentId: "sc-nd05cm-5"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css4;
});